// extracted by mini-css-extract-plugin
module.exports = {"spacer":"bf_cS"};